import { Stack, TextField as UITextField, Typography, useTheme } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

const TextField = ({
  required = false,
  maxSize = 0,
  name = '',
  forceError = null,
  deps = [],
  onChange = () => {},
  ...props
}) => {
  const { control } = useFormContext()
  const theme = useTheme()
  return (
    <Stack>
      <Controller
        name={name}
        control={control}
        rules={{ required, maxLength: maxSize, deps }}
        render={({ field, fieldState: { error } }) => (
          <>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{
                fontSize: '12px',
                lineHeight: '24px',
                fontWeight: '400',
                color: 'content.secondary'
              }}>
              <Typography
                sx={{
                  fontSize: '12px',
                  lineHeight: '24px',
                  fontWeight: '400',
                  visibility: props.label ? 'visible' : 'hidden'
                }}>{`${props.label}${required ? '*' : ''}`}</Typography>
              {maxSize > 0 && (
                <Typography
                  sx={{
                    fontSize: '12px',
                    lineHeight: '24px',
                    fontWeight: '400'
                  }}>{`${field.value?.length ?? '-'}/${maxSize}`}</Typography>
              )}
            </Stack>
            <UITextField
              {...props}
              {...field}
              helperText={forceError ? forceError : error ? error.message : ' '}
              label={null}
              fullWidth
              error={!!forceError || !!error}
              variant="outlined"
              sx={{
                background: 'white',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '6px',
                  '& fieldset': {
                    borderColor: theme.palette.grey['light'],
                  },
                  '&:hover fieldset': {
                    borderColor: theme.palette.primary.main,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: theme.palette.primary.main,
                  },
                },
              }}
              InputLabelProps={{
                sx: { left: field.value ? 0 : 30, top: field.value ? 0 : -10 },
                shrink: !!field.value
              }}
              onBlur={field.onBlur}
              onChange={e => {
                field.onChange(e.target.value)
                onChange(e.target.value)
              }}
            />
          </>
        )}
      />
    </Stack>
  )
}

export default TextField
